import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

import { easeIn, easeOut } from '../utils/curves';
import { mediumDurationMs } from '../utils/durations';
import KeyframesMotion from './keyframes-motion';
export const slideInAnimation = (from, state, fade) => {
  const initial = state === 'entering' ? '0%' : '100%';
  const end = state === 'entering' ? '100%' : '0%';
  const fromMap = {
    top: 'translate3d(0, -100%, 0)',
    right: 'translate3d(100%, 0, 0)',
    bottom: 'translate3d(0, 100%, 0)',
    left: 'translate3d(-100%, 0, 0)'
  };
  const animateOpacity = fade === 'inout' || fade === 'in' && state === 'entering' || fade === 'out' && state === 'exiting';
  return {
    [initial]: {
      transform: fromMap[from],
      opacity: animateOpacity ? 0 : 1
    },
    [end]: {
      transform: 'none',
      opacity: 1
    }
  };
};
/**
 * __SlideIn__
 *
 * Will slide an element into position, generally used for things that appear from outside of the viewport into view.
 *
 * See [examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions).
 */
const SlideIn = ({
  children,
  enterFrom,
  exitTo,
  fade = 'none',
  duration = mediumDurationMs,
  isPaused,
  onFinish,
  animationTimingFunction = state => state === 'entering' ? easeOut : easeIn
}) => {
  return /*#__PURE__*/React.createElement(KeyframesMotion, {
    duration: duration,
    enteringAnimation: slideInAnimation(enterFrom, 'entering', fade),
    exitingAnimation: slideInAnimation(exitTo || enterFrom, 'exiting', fade),
    animationTimingFunction: animationTimingFunction,
    isPaused: isPaused,
    onFinish: onFinish
  }, children);
};
export default SlideIn;